import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  CreateStaffsAPI,
  DeleteStaffsAPI,
  ListAllStaffsAPI,
  ListStaffsAPI,
  UpdateStaffsAPI,
} from "./staffs.api";

export const staffsKeys = {
  all: ["staffs"],
  lists: () => [...staffsKeys.all, "list"],
  list: (params) => [...staffsKeys.lists(), params],
};

export const useStaffsListQuery = (params) =>
  useQuery({
    queryKey: staffsKeys.list(params),
    queryFn: () => ListStaffsAPI(params),
  });

export const useAllStaffsExportMutation = () =>
  useMutation({
    mutationFn: ListAllStaffsAPI,
  });

export const useCreateStaffsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: CreateStaffsAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: staffsKeys.lists() });
    },
  });
};

export const useUpdateStaffsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: UpdateStaffsAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: staffsKeys.lists() });
    },
  });
};

export const useDeleteStaffsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: DeleteStaffsAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: staffsKeys.lists() });
    },
  });
};
